import { render, staticRenderFns } from "./TaskList.vue?vue&type=template&id=3a5a7d59"
import script from "./TaskList.vue?vue&type=script&lang=ts"
export * from "./TaskList.vue?vue&type=script&lang=ts"
import style0 from "./TaskList.vue?vue&type=style&index=0&id=3a5a7d59&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports